import { gql } from '@apollo/client';

export const APPLICATION_THEME_QUERY = gql`
  query applicationTheme {
    applicationTheme {
      themeName
    }
  }
`;

export const BRANDING_QUERY = gql`
  query brandingData($dealerId: Int!) {
    brandingData(dealerId: $dealerId) {
      themeName
      hasLogo
      hasSmallLogo
      dealerId
    }
  }
`;
export const DEALERS_QUERY = gql`
  query dealerBranding {
    dealerBranding {
      partnerId
      partnerName
    }
  }
`;
